import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, HostListener } from '@angular/core';
import { ButtonInterface } from '@components/components/button/button.component';

@Component({
  selector: 'sp-modal',
  standalone: false,
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']

})
export class ModalComponent implements OnInit, ModalObjectInterface {
  @ViewChild('modal', { static: true }) modal;
  @ViewChild('overly', { static: false }) overly;
  @Input() set open(value: boolean) {
    this._open = value;
  }

  get open(): boolean {
    return this._open;
  }

  constructor() {}
  @ViewChild('codeInput', { static: false }) codeInput: ElementRef;
  @Input() spTitle = 'Modal Title';
  @Input() style = 'light';
  @Input() type = 'default';
  @Input() side = 'none';
  _open: boolean;

  isClosed: boolean = false;

  @Input() showActions = false;
  @Input() showHeader = false;
  @Input() actions = [];

  @Output() toggle = new EventEmitter<boolean>();

  ngOnInit() {}

  @HostListener('window:keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape' && this._open) {
      if (this.modal) {
        this.modal.nativeElement.removeAttribute('style');
      }
      if (this.overly) {
        this.overly.nativeElement.removeAttribute('style');
      }

      this._open = false;
      if (this.toggle) {
        this.toggle.emit(this.open);
      }
    }
  }


  onToggleEvent() {
    this._open = !this._open;
    if (this.toggle) {
      this.toggle.emit(this.open);
    }
    if (this.side === 'left') {
      this.modal.nativeElement.removeAttribute('style');
    }
    if (this.overly) {
      this.overly.nativeElement.removeAttribute('style');
    }
    return this.open;
  }
}

export interface ModalObjectInterface {
  spTitle?: string;
  style?: string;
  type?: string;
  side?: string;
  open: boolean;
  showHeader?: boolean;
  showActions?: boolean;
  actions?: Array<ButtonInterface>;
}